
export const OrderPositionStatusConstants = {
    PositionStatusIdDefault: 'default',
    PositionStatusIdCancellationPending: 'cancellationPending',
    PositionStatusIdCancelled: 'cancelled',

    PositionStatusDisplayNameDefault: $localize`Gekauft`,
    PositionStatusDisplayNameCancellationPending: $localize`Storno angefordert`,
    PositionStatusDisplayNameCancelled: $localize`Storniert`,
}

export class OrderPositionStatus {
    public Id: string;
    public DisplayName: string;
}
